module.exports = __webpack_public_path__ + "img/manage-account-active.1469b522.svg";